import React, { useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito que mi esposo o hijos se vayan de casa?',
    a: 'No. El protocolo está diseñado para funcionar en el caos de la vida real, no en un vacío.'
  }, {
    q: '¿Cuánto tiempo al día requiere?',
    a: 'Menos de 10 minutos repartidos en pequeñas dosis de 2 o 3 minutos mientras haces tus actividades diarias.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un producto digital de descarga inmediata. Puedes leerlo en tu celular o tablet hoy mismo.'
  }, {
    q: '¿Qué pasa si mi agotamiento es muy severo?',
    a: "Este plan detiene la 'hemorragia' de energía. Es el primer paso crítico para que luego tengas la claridad de tomar decisiones de vida más grandes."
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-9">
      <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-10">
        <h2 className="text-3xl md:text-4xl font-serif text-teal text-center mb-12" data-id="element-11">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-12">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden border border-sage/50 shadow-sm" data-id="element-13">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-14">
                <span className="font-serif text-lg text-teal pr-4" data-id="element-15">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-16" />
              </button>
              <div className={`transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-17">
                <div className="px-6 pb-5 text-charcoal/80" data-id="element-18">{faq.a}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}